var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"w-full px-4 pb-5 pt-5 md:pt-10"},[_c('div',{staticClass:"flex w-full max-w-6xl my-0 mx-auto pr-5 justify-center items-center"},[_c('img',{attrs:{"src":require("@/assets/images/img_tm_lockup_red.png"),"width":"176","height":"32","alt":"Logo"}})])])
}]

export { render, staticRenderFns }